import React from 'react';
import PropTypes from 'prop-types';
import { SegmentControl } from '@zola/zola-ui';

const ViewSelector = ({ setView, view }) => (
  <SegmentControl
    activeSegment={view === 'CHART' ? 0 : 1}
    className="sc__view-selector"
    onClick={value => setView(value)}
    segments={[
      { key: 'CHART', text: 'Chart' },
      { key: 'LIST', text: 'List' }
    ]}
  />
);

ViewSelector.propTypes = {
  setView: PropTypes.func,
  view: PropTypes.string,
};

export default ViewSelector;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ViewSelector/ViewSelector.jsx